import { MapController } from "./map.controller";

angular
    .module("thor.core.map.component", [])
    .component("thorMap", {
        bindings: {
            coords: "<",
            onDragEnd: "&",
            isDraggable: "<"
        },
        controller: MapController,
        controllerAs: "mapCtrl",
        template: require("../../core/map/map.html")
    });
